"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueWrapper = exports.UntoggledValue = exports.StyledToggledInput = void 0;
const styles_1 = require("@mui/material/styles");
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
exports.StyledToggledInput = (0, styles_1.styled)(TextField_1.default)(({ theme }) => ({
    backgroundColor: "transparent",
    border: "none",
    outline: "none",
    fieldset: {
        borderColor: "transparent !important",
        outlineColor: "transparent",
    },
    input: {
        fontSize: "36px",
        fontWeight: "bold",
        padding: "0px !important",
        color: theme.palette.grayScale.gray2,
    },
    "& .MuiFormHelperText-root.Mui-error": {
        fontWeight: "bold",
        fontSize: "14px"
    },
}));
exports.UntoggledValue = (0, styles_1.styled)(Typography_1.default)(({ theme }) => ({
    color: theme.palette.grayScale.gray4,
    fontWeight: "bold",
    cursor: "pointer"
}));
exports.ValueWrapper = (0, styles_1.styled)("span")({
    display: "flex",
    alignItems: "center",
    button: {
        marginLeft: "12px",
    },
});
